import { render, staticRenderFns } from "./Conteudo.vue?vue&type=template&id=5c7368a8&scoped=true&lang=pug&"
import script from "./Conteudo.vue?vue&type=script&lang=js&"
export * from "./Conteudo.vue?vue&type=script&lang=js&"
import style0 from "./Conteudo.styl?vue&type=style&index=0&id=5c7368a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7368a8",
  null
  
)

export default component.exports